module.exports = __webpack_public_path__ + "static/index/img/android.05034330.png";